'use client';

import { PulseButton } from 'src/components/PulseUI';

interface FullPageErrorProps {
  title: string;
  description: string;
  buttonLabel?: string;
  onButtonClick?: () => void;
  children?: React.ReactNode;
  'data-testid'?: string;
}

/**
 * Shared full-page centered error layout used by PageErrorState and
 * ApiErrorOverlay. Keeps the error page structure DRY.
 */
const FullPageError = ({
  title,
  description,
  buttonLabel = 'Try again',
  onButtonClick,
  children,
  'data-testid': testId = 'full-page-error',
}: FullPageErrorProps) => (
  <div
    className="flex h-screen items-center justify-center px-4"
    data-testid={testId}
    role="alert"
  >
    <div className="flex max-w-lg flex-col items-center gap-6 text-center">
      <div className="flex flex-col gap-2">
        <h1 className="text-3xl font-bold text-secondary">{title}</h1>
        <p className="leading-relaxed text-neutral-500">{description}</p>
        {children}
      </div>
      {onButtonClick && (
        <PulseButton
          variant="solid"
          color="primary"
          onClick={onButtonClick}
          data-testid={`${testId}-try-again`}
        >
          {buttonLabel}
        </PulseButton>
      )}
    </div>
  </div>
);

export default FullPageError;
